import React, { useState } from 'react';
import { useTranslation } from '../utils/translations';

interface UnderstandingSurveyProps {
  onSubmit: (percentage: number) => void;
  nativeLanguage?: string;
}

export function UnderstandingSurvey({ onSubmit, nativeLanguage }: UnderstandingSurveyProps) {
  const [understanding, setUnderstanding] = useState(50);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t, isRTL } = useTranslation(nativeLanguage);

  const handleSubmit = () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    onSubmit(understanding);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full" dir={isRTL ? 'rtl' : 'ltr'}>
        <h2 className="text-2xl font-bold text-center text-gray-900 mb-4">
          {t('How much did you understand?')}
        </h2>
        <p className="text-gray-600 text-center mb-8">
          {t('Drag the slider to indicate your understanding level')}
        </p>

        <div className="mb-8">
          <input
            type="range"
            min="0"
            max="100"
            value={understanding}
            onChange={(e) => setUnderstanding(Number(e.target.value))}
            className={`w-full understanding-slider mb-2 ${isRTL ? 'understanding-slider-rtl' : ''}`}
          />

          <div className="flex justify-between text-sm text-gray-500 mt-2">
            <span>{t("Don't understand")}</span>
            <span>{t('Fully understand')}</span>
          </div>
        </div>

        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 shadow-lg">
            <span className="text-4xl font-bold text-white">{understanding}%</span>
          </div>
        </div>

        <button
          onClick={handleSubmit}
          disabled={isSubmitting}
          className={`w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors shadow-md hover:shadow-lg ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`}
        >
          {t('Continue')}
        </button>
      </div>
    </div>
  );
}
